import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import localforage from "localforage";

/** Storage key for the persisted query cache (IndexedDB via localforage). */
export const PERSIST_QUERY_CACHE_KEY = "komut-query-cache";

const queryCacheStorage = localforage.createInstance({
  name: "komut",
  storeName: "query-cache",
});

/**
 * Async persister for TanStack Query cache (T3-style: persistence at provider layer).
 * Uses localforage (IndexedDB) so cache survives refresh and gives instant replay on open.
 * Only safe to use in the browser; do not call during SSR.
 */
export function createQueryCachePersister() {
  return createAsyncStoragePersister({
    storage: {
      getItem: async (key) => (await queryCacheStorage.getItem<string>(key)) ?? null,
      setItem: async (key, value) => {
        await queryCacheStorage.setItem(key, value);
      },
      removeItem: async (key) => {
        await queryCacheStorage.removeItem(key);
      },
    },
    key: PERSIST_QUERY_CACHE_KEY,
    throttleTime: 1000,
  });
}

/** Clear persisted query cache (e.g. on sign-out). Call from client only. */
export async function clearPersistedQueryCache(): Promise<void> {
  await queryCacheStorage.removeItem(PERSIST_QUERY_CACHE_KEY);
}
